















import { Component, Prop, Vue } from 'vue-property-decorator';
import { mdbRow, mdbCol, mdbInput, mdbSelect } from '@folky-tools/mdbvue';
import { Reference } from '@/models/references/reference';

@Component({
    components: {
        mdbRow,
        mdbCol,
        mdbInput,
        mdbSelect
    }
})
export default class ReferenceStockLevels extends Vue {
    @Prop(Reference) private reference!: Reference;

    private async beforeMount(): Promise<void> {
        if (this.reference.skus && this.reference.skus.length > 0) {
            const skusCopy = this.reference.skus.map(sku => sku.clone());
            skusCopy.forEach(sku => {
                sku.stockLevelLabel = `${sku.code ? sku.code : ''}`;

                if (sku.attributes && sku.attributes.length > 0) {
                    sku.attributes.forEach(attribute => {
                        sku.stockLevelLabel += ` | ${attribute.name} ${attribute.values[0].name}`;
                    });
                }

                if (sku.discountedPrice) {
                    sku.stockLevelLabel += ` | ${this.$n(sku.discountedPrice, 'currency')}`;
                } else if (sku.price) {
                    sku.stockLevelLabel += ` | ${this.$n(sku.price, 'currency')}`;
                }

                if (sku.stockLevelLabel) {
                    sku.stockLevelLabel = sku.stockLevelLabel
                        .split(' | ')
                        .filter(s => s)
                        .join(' | ');
                }
            });
            this.reference.skus = skusCopy.map(sku => sku.clone());
        }
    }
}
